<template>
    <div class="w-full h-[56.2vw] relative overflow-hidden">
        <img src="../../assets/img/Desktop/DeepStrategy/1.webp" alt="" class="w-full h-auto absolute top-0 translate-y-[-76vw] blur-[1.2vw]">
        <div class="flex flex-col items-start absolute top-[9.16vw] left-[11.04vw]">
            <p class="text-[6.76vw] font-emeritus text-gradient leading-[5vw]  tracking-[-0.5vw] [text-shadow:0.2vw_0.2vw_#00000025]">SUMMON</p>
            <p class="text-[2.684375vw] font-emeritus uppercase text-gradient-2 tracking-[0.15vw] [text-shadow:0.1vw_0.1vw_#00000025]">Legendary Heroes</p>
            <p class="text-[1.04vw] font-league text-white ">Hundreds of unique heroes, each with their own skills and traits. Collect, upgrade, and create your unstoppable army</p>
        </div>
        <div class="w-[3vw] h-[10vw] absolute top-[9.16vw] right-[36vw] flex flex-col justify-between items-center">
            <div class="w-[0.25vw] h-[0.25vw] rotate-[45deg] bg-white"></div>
            <div class="w-[0.1vw] h-full bg-white"></div>
            <div class="w-[0.25vw] h-[0.25vw] rotate-[45deg] bg-white"></div>
        </div>
        <div class="absolute top-[21.15vw] h-[27.75vw] radius-container left-[8.5vw] w-[83vw] overflow-hidden">
            
            <img src="../../assets/img/Desktop/SummonLegendaryHeroes/7.webp" alt="" class="w-full translate-y-[-15vw] scale-[1.05]">
            <!-- Content -->
            <div class="w-[74vw] flex flex-row justify-between absolute left-[4.5vw] top-0">
                <!-- items 1 -->
                <div class="items-to-hover relative flex justify-center translate-y-[11vw]">
                    <img src="../../assets/img/Desktop/SummonLegendaryHeroes/2.webp" alt="" class="w-[12.65625vw]">
                    <div class="absolute top-[12.5vw] w-[12vw] flex flex-col">
                        <p class="text-[1.13125vw] text-white font-emeritus [text-shadow:0.1vw_0.1vw_#00000025]">Morgan Magic</p>
                        <div class="flex flex-row justify-between">
                            <!-- 1 -->
                            <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/SummonLegendaryHeroes/10.webp" alt="" class="w-[1.5vw] h-[1.4vw]">
                                <div class="flex flex-col justify-between pl-[0.25vw]">
                                    <p class="text-[0.9vw] font-emeritus text-white">560</p>
                                    <p class="text-[0.68vw] font-league text-white">Health</p>
                                </div>
                            </div>
                            <div class="w-[0.1vw] h-[1.8vw] bg-white translate-y-[0.25vw]"></div>
                            <!-- 2 -->
                             <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/SummonLegendaryHeroes/9.webp" alt="" class="w-[1.5vw] h-[1.4vw]">
                                <div class="flex flex-col justify-between pl-[0.25vw]">
                                    <p class="text-[0.9vw] font-emeritus text-white">70</p>
                                    <p class="text-[0.68vw] font-league text-white">Attack</p>
                                </div>
                            </div>
                            <div class="w-[0.1vw] h-[1.8vw] bg-white translate-y-[0.25vw]"></div>
                            <!-- 3 -->
                             <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/SummonLegendaryHeroes/1.webp" alt="" class="w-[1.5vw] h-[1.4vw]">
                                <div class="flex flex-col justify-between pl-[0.25vw]">
                                    <p class="text-[0.9vw] font-emeritus text-white">10</p>
                                    <p class="text-[0.68vw] font-league text-white">Amor</p>
                                </div>
                            </div>
                        </div>
                        <!-- button -->
                        <div class="w-[12vw] h-[2.55vw] flex justify-center mt-[0.5vw]">
                            <img src="../../assets/img/Desktop/SummonLegendaryHeroes/SummonNow.webp" alt="" class="h-[2.55vw] hover:cursor-pointer" @click="openWebLink('https://play.idle-glory.io/')">
                        </div>
                    </div>
                </div>
                <!-- Items 2 -->
                 <div class="items-to-hover relative flex justify-center translate-y-[11vw]">
                    <img src="../../assets/img/Desktop/SummonLegendaryHeroes/3.webp" alt="" class="w-[12.65625vw]">
                    <div class="absolute top-[12.5vw] w-[12vw] flex flex-col">
                        <p class="text-[1.13125vw] text-white font-emeritus [text-shadow:0.1vw_0.1vw_#00000025]">Doomhowl</p>
                        <div class="flex flex-row justify-between">
                            <!-- 1 -->
                            <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/SummonLegendaryHeroes/10.webp" alt="" class="w-[1.5vw] h-[1.4vw]">
                                <div class="flex flex-col justify-between pl-[0.25vw]">
                                    <p class="text-[0.9vw] font-emeritus text-white">680</p>
                                    <p class="text-[0.68vw] font-league text-white">Health</p>
                                </div>
                            </div>
                            <div class="w-[0.1vw] h-[1.8vw] bg-white translate-y-[0.25vw]"></div>
                            <!-- 2 -->
                             <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/SummonLegendaryHeroes/9.webp" alt="" class="w-[1.5vw] h-[1.4vw]">
                                <div class="flex flex-col justify-between pl-[0.25vw]">
                                    <p class="text-[0.9vw] font-emeritus text-white">78</p>
                                    <p class="text-[0.68vw] font-league text-white">Attack</p>
                                </div>
                            </div>
                            <div class="w-[0.1vw] h-[1.8vw] bg-white translate-y-[0.25vw]"></div>
                            <!-- 3 -->
                             <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/SummonLegendaryHeroes/1.webp" alt="" class="w-[1.5vw] h-[1.4vw]">
                                <div class="flex flex-col justify-between pl-[0.25vw]">
                                    <p class="text-[0.9vw] font-emeritus text-white">16</p>
                                    <p class="text-[0.68vw] font-league text-white">Amor</p>
                                </div>
                            </div>
                        </div>
                        <!-- button -->
                        <div class="w-[12vw] h-[2.55vw] flex justify-center mt-[0.5vw]">
                            <img src="../../assets/img/Desktop/SummonLegendaryHeroes/SummonNow.webp" alt="" class="h-[2.55vw] hover:cursor-pointer" @click="openWebLink('https://play.idle-glory.io/')">
                        </div>
                    </div>
                </div>
                <!-- Items 3 -->
                 <div class="items-to-hover relative flex justify-center translate-y-[11vw]">
                    <img src="../../assets/img/Desktop/SummonLegendaryHeroes/4.webp" alt="" class="w-[12.65625vw]">
                    <div class="absolute top-[12.5vw] w-[12vw] flex flex-col">
                        <p class="text-[1.13125vw] text-white font-emeritus [text-shadow:0.1vw_0.1vw_#00000025]">Elezar Icecaller</p>
                        <div class="flex flex-row justify-between">
                            <!-- 1 -->
                            <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/SummonLegendaryHeroes/10.webp" alt="" class="w-[1.5vw] h-[1.4vw]">
                                <div class="flex flex-col justify-between pl-[0.25vw]">
                                    <p class="text-[0.9vw] font-emeritus text-white">620</p>
                                    <p class="text-[0.68vw] font-league text-white">Health</p>
                                </div>
                            </div>
                            <div class="w-[0.1vw] h-[1.8vw] bg-white translate-y-[0.25vw]"></div>
                            <!-- 2 -->
                             <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/SummonLegendaryHeroes/9.webp" alt="" class="w-[1.5vw] h-[1.4vw]">
                                <div class="flex flex-col justify-between pl-[0.25vw]">
                                    <p class="text-[0.9vw] font-emeritus text-white">66</p>
                                    <p class="text-[0.68vw] font-league text-white">Attack</p>
                                </div>
                            </div>
                            <div class="w-[0.1vw] h-[1.8vw] bg-white translate-y-[0.25vw]"></div>
                            <!-- 3 -->
                             <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/SummonLegendaryHeroes/1.webp" alt="" class="w-[1.5vw] h-[1.4vw]">
                                <div class="flex flex-col justify-between pl-[0.25vw]">
                                    <p class="text-[0.9vw] font-emeritus text-white">13</p>
                                    <p class="text-[0.68vw] font-league text-white">Amor</p>
                                </div>
                            </div>
                        </div>
                        <!-- button -->
                        <div class="w-[12vw] h-[2.55vw] flex justify-center mt-[0.5vw]">
                            <img src="../../assets/img/Desktop/SummonLegendaryHeroes/SummonNow.webp" alt="" class="h-[2.55vw] hover:cursor-pointer" @click="openWebLink('https://play.idle-glory.io/')">
                        </div>
                    </div>
                </div>
                <!-- Items 4 -->
                 <div class="items-to-hover relative flex justify-center translate-y-[11vw]">
                    <img src="../../assets/img/Desktop/SummonLegendaryHeroes/5.webp" alt="" class="w-[12.65625vw]">
                    <div class="absolute top-[12.5vw] w-[12vw] flex flex-col">
                        <p class="text-[1.13125vw] text-white font-emeritus [text-shadow:0.1vw_0.1vw_#00000025]">Molok Steelhorn</p>
                        <div class="flex flex-row justify-between">
                            <!-- 1 -->
                            <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/SummonLegendaryHeroes/10.webp" alt="" class="w-[1.5vw] h-[1.4vw]">
                                <div class="flex flex-col justify-between pl-[0.25vw]">
                                    <p class="text-[0.9vw] font-emeritus text-white">700</p>
                                    <p class="text-[0.68vw] font-league text-white">Health</p>
                                </div>
                            </div>
                            <div class="w-[0.1vw] h-[1.8vw] bg-white translate-y-[0.25vw]"></div>
                            <!-- 2 -->
                             <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/SummonLegendaryHeroes/9.webp" alt="" class="w-[1.5vw] h-[1.4vw]">
                                <div class="flex flex-col justify-between pl-[0.25vw]">
                                    <p class="text-[0.9vw] font-emeritus text-white">80</p>
                                    <p class="text-[0.68vw] font-league text-white">Attack</p>
                                </div>
                            </div>
                            <div class="w-[0.1vw] h-[1.8vw] bg-white translate-y-[0.25vw]"></div>
                            <!-- 3 -->
                             <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/SummonLegendaryHeroes/1.webp" alt="" class="w-[1.5vw] h-[1.4vw]">
                                <div class="flex flex-col justify-between pl-[0.25vw]">
                                    <p class="text-[0.9vw] font-emeritus text-white">14</p>
                                    <p class="text-[0.68vw] font-league text-white">Amor</p>
                                </div>
                            </div>
                        </div>
                        <!-- button -->
                        <div class="w-[12vw] h-[2.55vw] flex justify-center mt-[0.5vw]">
                            <img src="../../assets/img/Desktop/SummonLegendaryHeroes/SummonNow.webp" alt="" class="h-[2.55vw] hover:cursor-pointer" @click="openWebLink('https://play.idle-glory.io/')">
                        </div>
                    </div>
                </div>
                <!-- Items 5 -->
                 <div class="items-to-hover relative flex justify-center translate-y-[11vw]">
                    <img src="../../assets/img/Desktop/SummonLegendaryHeroes/6.webp" alt="" class="w-[12.65625vw]">
                    <div class="absolute top-[12.5vw] w-[12vw] flex flex-col">
                        <p class="text-[1.13125vw] text-white font-emeritus [text-shadow:0.1vw_0.1vw_#00000025]">Baron Goldchest</p>
                        <div class="flex flex-row justify-between">
                            <!-- 1 -->
                            <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/SummonLegendaryHeroes/10.webp" alt="" class="w-[1.5vw] h-[1.4vw]">
                                <div class="flex flex-col justify-between pl-[0.25vw]">
                                    <p class="text-[0.9vw] font-emeritus text-white">590</p>
                                    <p class="text-[0.68vw] font-league text-white">Health</p>
                                </div>
                            </div>
                            <div class="w-[0.1vw] h-[1.8vw] bg-white translate-y-[0.25vw]"></div>
                            <!-- 2 -->
                             <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/SummonLegendaryHeroes/9.webp" alt="" class="w-[1.5vw] h-[1.4vw]">
                                <div class="flex flex-col justify-between pl-[0.25vw]">
                                    <p class="text-[0.9vw] font-emeritus text-white">75</p>
                                    <p class="text-[0.68vw] font-league text-white">Attack</p>
                                </div>
                            </div>
                            <div class="w-[0.1vw] h-[1.8vw] bg-white translate-y-[0.25vw]"></div>
                            <!-- 3 -->
                             <div class="flex flex-row items-center">
                                <img src="../../assets/img/Desktop/SummonLegendaryHeroes/1.webp" alt="" class="w-[1.5vw] h-[1.4vw]">
                                <div class="flex flex-col justify-between pl-[0.25vw]">
                                    <p class="text-[0.9vw] font-emeritus text-white">11</p>
                                    <p class="text-[0.68vw] font-league text-white">Amor</p>
                                </div>
                            </div>
                        </div>
                        <!-- button -->
                        <div class="w-[12vw] h-[2.55vw] flex justify-center mt-[0.5vw]">
                            <img src="../../assets/img/Desktop/SummonLegendaryHeroes/SummonNow.webp" alt="" class="h-[2.55vw] hover:cursor-pointer" @click="openWebLink('https://play.idle-glory.io/')">
                        </div>
                    </div>
                </div>
            </div>
            <div class="absolute top-[0vw] w-[83vw] h-[0.1vw] bg-gradient-to-r from-transparent via-[#F3FD93] to-transparent"></div>
            <div class="absolute bottom-0 w-[83vw] h-[0.1vw] bg-gradient-to-r from-transparent via-[#F3FD93] to-transparent"></div>
        </div>
    </div>
</template>

<script setup>
function openWebLink(url) {
  setTimeout(() => {
    window.open(url, "_blank");
  }, 300);
}
</script>

<style scoped>
.font-emeritus {
  font-family: "Emeritus", sans-serif;
}

.font-league {
  font-family: "LeagueSpartan", sans-serif;
}

.text-gradient {
  background: linear-gradient(to top right, 
    #C5EEFF 0%, 
    #E8E8E8 50%, 
    #F4FF8D 100%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.text-gradient-2{
    background: linear-gradient(to top, 
    #FEE7EB 0%, 
    #FEF9D8 80%
  );
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.radius-container {
    border-radius: 1.5vw; 
}

.items-to-hover{
    transform:  translateY(11vw);
    transition: all 500ms ease-in-out;
}

.items-to-hover:hover {
    transform:  translateY(7vw);
    transition: all 500ms ease-in-out;
}
</style>